import {Provider} from '@angular/core';

import {
  GetConfigUseCaseProvider
} from '@features/app-config/presentation/providers/get-config/get-config.use-case.provider';

import {GetConfigFacade} from '@features/app-config/presentation/facades/get-config/get-config.facade';

export const GetConfigFacadeProvider: Provider[] = [
  GetConfigUseCaseProvider,
  GetConfigFacade
];
